/** 나의 폐암 정보 */
export const UPDATE_LUNG = "UPDATE_LUNG";
export const GET_LUNG_TOTAL = "GET_LUNG_TOTAL"; // 나의 폐암 총점 구하기
export const GET_LUNG_TOTAL_SUCCESS = "GET_LUNG_TOTAL_SUCCESS"; // 나의 폐암 총점 구하기 성공
export const GET_LUNG_TOTAL_FAIL = "GET_LUNG_TOTAL_FAIL"; // 나의 폐암 총점 구하기 실패

/** 나의 전립선암 정보 */
export const UPDATE_PROSTATE = "UPDATE_PROSTATE";
export const GET_PROSTATE_TOTAL = "GET_PROSTATE_TOTAL"; // 나의 전립선암 총점 구하기
export const GET_PROSTATE_TOTAL_SUCCESS = "GET_PROSTATE_TOTAL_SUCCESS"; // 나의 전립선암 총점 구하기 성공
export const GET_PROSTATE_TOTAL_FAIL = "GET_PROSTATE_TOTAL_FAIL"; // 나의 전립선암 총점 구하기 실패

/** 나의 유방암 정보 */
export const UPDATE_BREAST = "UPDATE_BREAST";
export const GET_BREAST_TOTAL = "GET_BREAST_TOTAL"; // 나의 유방암 총점 구하기
export const GET_BREAST_TOTAL_SUCCESS = "GET_BREAST_TOTAL_SUCCESS"; // 나의 유방암 총점 구하기 성공
export const GET_BREAST_TOTAL_FAIL = "GET_BREAST_TOTAL_FAIL"; // 나의 유방암 총점 구하기 실패

/** 나의 유방암 정보 */
export const UPDATE_THYROID = "UPDATE_THYROID";
export const GET_THYROID_TOTAL = "GET_THYROID_TOTAL"; // 나의 갑상선암 총점 구하기
export const GET_THYROID_TOTAL_SUCCESS = "GET_THYROID_TOTAL_SUCCESS"; // 나의 갑상선암 총점 구하기 성공
export const GET_THYROID_TOTAL_FAIL = "GET_THYROID_TOTAL_FAIL"; // 나의 갑상선암 총점 구하기 실패

/** 설문 정보 */
export const GET_SERVEY_LIST = "GET_SERVEY_LIST"; // 설문 리스트 요청
export const GET_SERVEY_LIST_SUCCESS = "GET_SERVEY_LIST_SUCCESS"; // 설문 리스트 요청 성공
export const GET_SERVEY_LIST_FAIL = "GET_SERVEY_LIST_FAIL"; // 설문 리스트 요청 실패

/* 설문 정보 ADD */
export const ADD_SERVEY = "ADD_SURVEY"; // 설문 작성
export const ADD_SERVEY_SUCCESS = "ADD_SERVEY_SUCCESS"; // 설문 작성 성공
export const ADD_SERVEY_FAIL = "ADD_SERVEY_FAIL"; // 설문 작성 실패

/* 위험도 계산 결과 ADD */
export const ADD_TOTAL = "ADD_TOTAL"; //  위험도 계산 결과 작성
export const ADD_TOTAL_SUCCESS = "ADD_TOTAL_SUCCESS"; // 위험도 계산 결과 성공
export const ADD_TOTAL_FAIL = "ADD_TOTAL_FAIL"; // 위험도 계산 결과 실패

// 로딩
export const START_LOADING = "START_LOADING";
export const FINISH_LOADING = "FINISH_LOADING";
